import { render, staticRenderFns } from "./insectItem.vue?vue&type=template&id=05b6690c&"
import script from "./insectItem.vue?vue&type=script&lang=js&"
export * from "./insectItem.vue?vue&type=script&lang=js&"
import style0 from "./insectItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports